// extracted by mini-css-extract-plugin
export default {"clarification":"ResetPassPage_clarification__y1Lld","link":"ResetPassPage_link__kkioQ"};